// ----------------------------------------------------------------------

const account = {
  displayName: 'Plataforma ENEX',
};

export default account;
